import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, cn, formatPersonName, IconButton } from "@cca/components";
import { useUserInfo } from "@core/hooks";
import { MockAuthService } from "@services";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

type SidebarUserInfoProps = {
  collapsed: boolean;
  onAvatarClick: () => void;
};

const SidebarUserInfo = ({
  onAvatarClick,
  collapsed,
}: SidebarUserInfoProps) => {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  const logoutCallback = useCallback(
    async (returnTo: string) => {
      if (rspkr.ui) rspkr.ui.destroyActivePlayer();
      localStorage.removeItem("unleash:repository:repo");
      localStorage.removeItem("unleash:repository:sessionId");
      if (MockAuthService.isEnabled && MockAuthService.isAuthorized) {
        MockAuthService.logout();
        navigate("/");
      } else {
        logout({
          logoutParams: { returnTo },
        });
      }
    },
    [logout, navigate],
  );

  const userInfo = useUserInfo();

  if (!userInfo) return null;

  const { firstName, lastName, profileImageUrl } = userInfo;

  return (
    <div className="flex items-center gap-3 px-4 pb-6">
      <button onClick={onAvatarClick}>
        <Avatar
          alt={formatPersonName(firstName, lastName)}
          monochrome
          src={profileImageUrl}
        />
      </button>
      <div
        className={cn("flex flex-1 items-center justify-between duration-300", {
          "opacity-0": collapsed,
        })}
      >
        <span className="text-sm font-bold break-all text-gray-800">
          {firstName}
        </span>
        <span data-testid="logout-icon">
          <IconButton
            aria-label="Logout"
            color="info"
            icon="arrow-right-from-bracket"
            onClick={() => logoutCallback(window.location.origin)}
            tabIndex={collapsed ? -1 : 0}
          />
        </span>
      </div>
    </div>
  );
};

export default SidebarUserInfo;
